import { IAttrValue } from "@multiweb/types/contracts";
import { createElement } from "../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { Column } from "../../Columns/Column";
import { ItemTemplate } from "../ItemTemplate";

export class CalendarItemTemplate extends ItemTemplate {
    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        const content = await this._createDataElement(dataSet, this.parentColumn);
        item.innerHTML = "";
        item.appendChild(content);
    }

    private async _createDataElement(dataSet: IAttrValue[], column: Column): Promise<HTMLDivElement> {
        const innerElement = createElement({ classes: "calendar-template value" }) as HTMLDivElement;
        const dataElement = createElement({ classes: "calendar-template content" });
        const spanElement = document.createElement("span");
        dataElement.textContent = await this._getJoinData(dataSet, column);

        spanElement.appendChild(dataElement);
        innerElement.appendChild(spanElement);

        return innerElement;
    }
}
